export enum UserRoleTypes {
    ORGANIZATION_ADMINISTRATOR_ROLE = 'orgAdmin',
    ORGANIZATION_SERVICE_MANAGER_ROLE = 'orgServiceManager',
    ORGANIZATION_AUDITOR_ROLE = 'orgAuditor',
    ORGANIZATION_USER_ROLE = 'orgUser',
    ORGANIZATION_MANAGER_ROLE = 'orgManager',
    RP_ADMINISTRATOR_ROLE = "rpAdmin",
    RP_SERVICE_MANAGER_ROLE = "rpServiceManager",
    RP_AUDITOR_ROLE = "rpAuditor",
    RP_USER_ROLE = "rpUser",
    RP_MANAGER_ROLE = "rpManager"
}